import React, { useEffect, useState } from "react";
import { machines } from "../data/machines";
import CartItem from "../components/CartItem";
import "../css/Rental.css";

export default function Rental({ addToCart }) {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true); // Trigger animation on page load
    console.log("Animation state set to true"); // Debugging log
  }, []);

  return (
    <div style={{ padding: 0, margin: 0, background: "#f7f7f7", minHeight: "100vh" }}>
      {/* Full-width image banner */}
      <div
        className="hero-banner"
        style={{
          background: `linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), url('/Images/Image/view-heavy-machinery-used-construction-industry (2).jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h1
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "white",
            fontSize: "48px",
            fontWeight: "bold",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
            margin: 0,
          }}
        >
          RENTAL EQUIPMENTS
        </h1>
      </div>

      {/* Card items section */}
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "0 20px" }}>
        <div
          className={`card-container ${animate ? "animate" : ""}`}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "20px",
            justifyContent: "center",
            marginTop: "-20px", // Ensure cards touch the image
          }}
        >
          {machines.map((machine, index) => {
            const animationClass = index % 2 === 0 ? "slide-in-left" : "slide-in-right";
            return (
              <CartItem
                key={machine.id}
                item={{
                  name: machine.name,
                  price: machine.price,
                  image: machine.image || "/Images/default-machine.jpg",
                  description: machine.description || "High-quality machinery for your construction needs.",
                  features: machine.features || ["Free Repair Service", "Free Delivery Service", "One-Way Diesel Included"],
                }}
                className={animationClass} // Alternate animation direction
                style={{ animation: `${animationClass} 0.8s ease forwards` }} // Force animation inline
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}